import React, { Component } from 'react';
import {withRouter} from 'react-router-dom'
import { Grid, Row, PageHeader } from 'react-bootstrap';
import {firestoredb} from "../App";
import ArtistList from "../Components/ArtistList";
import Crummy from "../Components/Crummy";

class Artists extends Component {

  constructor(props) {
    super(props);
    this.getArtists = this.getArtists.bind(this);
    this.addArtistToList = this.addArtistToList.bind(this);
    this.gotoPage = this.gotoPage.bind(this);

    this.state = {
        artists: [],
        loaded: false
    };

    this.getArtists();

  }


  addArtistToList(doc) {
    var artistList = this.state.artists;
    artistList.push(doc.data());
    this.setState({artists: artistList})
  }

  getArtists() {
    firestoredb.collection("users")
      .where('isArtist', '==', true)
      .limit(10)
      .get()
      .then((artistList) => {
        artistList.forEach((doc) => {
          this.addArtistToList(doc);
        });
        this.setState({loaded: true})
      })
      .catch(() => function(error) {
          this.setState({loaded: true})
      });
  }

  gotoPage(event, props, page) {
    props.history.push("/", page);
  }

  breadcumb() {
    return (
      <Crummy
        paths={
        [
          {'name': 'Home', 'path': '/'},
        ]
      } page={'Artists'}/>
    );
  }

  loadingPage() {
      const breadcrumb = this.breadcumb();

        return (
            <Grid>
              {breadcrumb}
              <Row>
                    <PageHeader>Artists</PageHeader>
                </Row>
                <Row>
                    <div>
                        <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                    </div>
                </Row>
            </Grid>
        );
    }




    render() {

        const loadingPage = this.loadingPage();

          if (this.state.loaded === false) {
              return (<div>{loadingPage}</div>);
          }

          const breadcrumb = this.breadcumb();

        return (
          <Grid>
            {breadcrumb}
            <Row>
              <PageHeader>Artists</PageHeader>
            </Row>
            <Row>
              Artists Page {this.state.artists.length}
            </Row>
            <Row>
              <ArtistList artists={this.state.artists}/>
            </Row>
          </Grid>
        );
  }
}
export default withRouter(Artists);



// WEBPACK FOOTER //
// ./src/pages/Artists.jsx